// extracted by mini-css-extract-plugin
module.exports = {"container":"AnnouncementBanner_container__2ZsUG"};